import React from 'react';

import { GeojsonLayer } from '@foreflight/webmap/react';

import { useDebriefSegments } from 'ff/debrief/hooks';
import { iapToGeojson } from './utils/iapToGeojson';

const ApproachPlanLayer = () => {
    const { approachPlan } = useDebriefSegments();

    if (!approachPlan) {
        return null;
    }

    const geojson = iapToGeojson(approachPlan);

    // Style the features
    const features = geojson.features.map(feature => {
        const styledFeature = { ...feature };

        if (feature.geometry.type === 'LineString') {
            // Style line segments
            styledFeature.properties = {
                ...feature.properties,
                width: 3,
                cap: 'square',
                outlineColor: '#000',
                outlineWidth: 1,
            };
        } else if (feature.geometry.type === 'Point') {
            // Style fix points
            styledFeature.properties = {
                ...feature.properties,
                radius: 6,
                outlineColor: '#fff',
                outlineWidth: 2,
            };
        }

        return styledFeature;
    });

    return (
        // @ts-expect-error Issues with webmap exports
        <GeojsonLayer features={features} priority={25} />
    );
};

export default ApproachPlanLayer;
